import React from 'react';
import { UserDevicesProvider } from '../context/userDevices/provider';
import { SubscriptionConsentProvider } from '../context/subscriptionConsent';

export const withContext =
  (Component: any) =>
  ({ ...props }) => (
    <UserDevicesProvider>
      <SubscriptionConsentProvider>
        <Component {...props} />
      </SubscriptionConsentProvider>
    </UserDevicesProvider>
  );
